import { CalendarEvent, CalendarView } from 'angular-calendar';

import { createAction } from '../../../store.model';
import { User } from '../../../user/user.model';
import { ScheduleItem } from '../models/schedule.model';

// ACTIONS LIST
export enum ActionType {
    COACHING_CALENDAR__INIT = 'COACHING_CALENDAR__INIT',
    COACHING_CALENDAR__INIT_RESULT = 'COACHING_CALENDAR__INIT_RESULT',
    COACHING_CALENDAR__RELOAD = 'COACHING_CALENDAR__RELOAD',
    COACHING_CALENDAR__RELOAD_RESULT = 'COACHING_CALENDAR__RELOAD_RESULT',
    COACHING_CALENDAR__CHANGE_VIEW = 'COACHING_CALENDAR__CHANGE_VIEW',
    COACHING_CALENDAR__INIT_EVENT = 'COACHING_CALENDAR__INIT_EVENT',
}

// ACTION INIT
export interface RootInitAction {
    managerId: number;
}

// TODO add performerId
/** calendar probably will end up app wide. have the inputs be lean */
export const rootInit = createAction<ActionType, RootInitAction>(
    ActionType.COACHING_CALENDAR__INIT,
);

// ACTION RESULT
export interface RootInitResultAction extends RootInitAction {
    manager?: User;
}

export const rootInitResult = createAction<ActionType, RootInitResultAction>(
    ActionType.COACHING_CALENDAR__INIT_RESULT,
);

/// /////////////////

export interface RootReloadAction {
    performerId: number;
    view?: CalendarView;
    viewDate?: Date;
}

export const rootReload = createAction<ActionType, RootReloadAction>(
    ActionType.COACHING_CALENDAR__RELOAD,
);

export interface RootReloadResultAction extends RootReloadAction {
    // startDate?: Date;
    // endDate?: Date;
    events?: ScheduleItem[];
    calendarEvents?: CalendarEvent[];
}

export const rootReloadResult = createAction<
    ActionType,
    RootReloadResultAction
>(ActionType.COACHING_CALENDAR__RELOAD_RESULT);

/// /////////////////

export interface RootChangeView {
    view: CalendarView;
}

export const rootChangeView = createAction<ActionType, RootChangeView>(
    ActionType.COACHING_CALENDAR__CHANGE_VIEW,
);

/// /////////////////

// ACTION SET EVENT ID
export interface InitEventAction {
    eventId: number;
}

export const initEvent = createAction<ActionType, InitEventAction>(
    ActionType.COACHING_CALENDAR__INIT_EVENT,
);
